// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__qJGCL","colMaxWidth":"Table_colMaxWidth__ZK88U"};